import AMLSummary from '../AMLSummary/AMLSummary';

const AMLSummaryRow = ({ aml, index, lastItem, ...rest }) => {
	return (
		<AMLSummary
			{...rest}
			percent={aml?.RiskScore}
			isActualAML={aml?.IsActual}
			blockchainName={aml?.Blockchain}
			showBlockchain={true}
			highRisk={aml?.HighRisk}
			date={aml?.CheckDate ? aml?.CheckDate : aml?.Created}
			addressAmlId={aml?.Id}
			isLoading={aml?.Status === 'None' || aml?.Status === 'Pending' || aml?.Status === 'Aborted'}
			isError={aml?.Status === 'Failed' || aml?.Status === 'Canceled'}
			bottomSeparator={!lastItem}
			checkDate={aml?.CheckDate}
			address={aml?.Address}
		/>
	);
};

export default AMLSummaryRow;
